module.exports = __webpack_public_path__ + "img/2.9.3ebc3f0f.png";